export const nationalities_es = [
  {
    alpha2: "ES",
    value: "ESP",
    label: "España",
  },
  {
    alpha2: "AF",
    value: "AFG",
    label: "Afganistán",
  },
  {
    alpha2: "AX",
    value: "ALA",
    label: "Åland Islands",
  },
  {
    alpha2: "AL",
    value: "ALB",
    label: "Albania",
  },
  {
    alpha2: "DE",
    value: "DEU",
    label: "Alemania",
  },
  {
    alpha2: "AD",
    value: "AND",
    label: "Andorra",
  },
  {
    alpha2: "AO",
    value: "AGO",
    label: "Angola",
  },
  {
    alpha2: "AI",
    value: "AIA",
    label: "Anguila",
  },
  {
    alpha2: "AQ",
    value: "ATA",
    label: "Antártida",
  },
  {
    alpha2: "AG",
    value: "ATG",
    label: "Antigua y Barbuda",
  },
  {
    alpha2: "SA",
    value: "SAU",
    label: "Arabia Saudita",
  },
  {
    alpha2: "DZ",
    value: "DZA",
    label: "Argelia",
  },
  {
    alpha2: "AR",
    value: "ARG",
    label: "Argentina",
  },
  {
    alpha2: "AM",
    value: "ARM",
    label: "Armenia",
  },
  {
    alpha2: "AW",
    value: "ABW",
    label: "Aruba",
  },
  {
    alpha2: "AU",
    value: "AUS",
    label: "Australia",
  },
  {
    alpha2: "AT",
    value: "AUT",
    label: "Austria",
  },
  {
    alpha2: "AZ",
    value: "AZE",
    label: "Azerbaiyán",
  },
  {
    alpha2: "BS",
    value: "BHS",
    label: "Bahamas",
  },
  {
    alpha2: "BD",
    value: "BGD",
    label: "Bangladés",
  },
  {
    alpha2: "BB",
    value: "BRB",
    label: "Barbados",
  },
  {
    alpha2: "BH",
    value: "BHR",
    label: "Baréin",
  },
  {
    alpha2: "BE",
    value: "BEL",
    label: "Bélgica",
  },
  {
    alpha2: "BZ",
    value: "BLZ",
    label: "Belice",
  },
  {
    alpha2: "BJ",
    value: "BEN",
    label: "Benín",
  },
  {
    alpha2: "BM",
    value: "BMU",
    label: "Bermudas",
  },
  {
    alpha2: "BY",
    value: "BLR",
    label: "Bielorrusia",
  },
  {
    alpha2: "BO",
    value: "BOL",
    label: "Bolivia",
  },
  {
    alpha2: "BQ",
    value: "BES",
    label: "Bonaire",
  },
  {
    alpha2: "BA",
    value: "BIH",
    label: "Bosnia y Herzegovina",
  },
  {
    alpha2: "BW",
    value: "BWA",
    label: "Botsuana",
  },
  {
    alpha2: "BR",
    value: "BRA",
    label: "Brasil",
  },
  {
    alpha2: "BN",
    value: "BRN",
    label: "Brunéi Darussalam",
  },
  {
    alpha2: "BG",
    value: "BGR",
    label: "Bulgaria",
  },
  {
    alpha2: "BF",
    value: "BFA",
    label: "Burkina Faso",
  },
  {
    alpha2: "BI",
    value: "BDI",
    label: "Burundi",
  },
  {
    alpha2: "BT",
    value: "BTN",
    label: "Bután",
  },
  {
    alpha2: "CV",
    value: "CPV",
    label: "Cabo Verde",
  },
  {
    alpha2: "KH",
    value: "KHM",
    label: "Camboya",
  },
  {
    alpha2: "CM",
    value: "CMR",
    label: "Camerún",
  },
  {
    alpha2: "CA",
    value: "CAN",
    label: "Canadá",
  },
  {
    alpha2: "QA",
    value: "QAT",
    label: "Catar",
  },
  {
    alpha2: "TD",
    value: "TCD",
    label: "Chad",
  },
  {
    alpha2: "CL",
    value: "CHL",
    label: "Chile",
  },
  {
    alpha2: "CN",
    value: "CHN",
    label: "China",
  },
  {
    alpha2: "CY",
    value: "CYP",
    label: "Chipre",
  },
  {
    alpha2: "CO",
    value: "COL",
    label: "Colombia",
  },
  {
    alpha2: "KM",
    value: "COM",
    label: "Comoras",
  },
  {
    alpha2: "CG",
    value: "COG",
    label: "Congo",
  },
  {
    alpha2: "CD",
    value: "COD",
    label: "Congo, Democratic Republic of the",
  },
  {
    alpha2: "KR",
    value: "KOR",
    label: "Corea",
  },
  {
    alpha2: "CI",
    value: "CIV",
    label: "Costa de Marfil",
  },
  {
    alpha2: "CR",
    value: "CRI",
    label: "Costa Rica",
  },
  {
    alpha2: "HR",
    value: "HRV",
    label: "Croacia",
  },
  {
    alpha2: "CU",
    value: "CUB",
    label: "Cuba",
  },
  {
    alpha2: "CW",
    value: "CUW",
    label: "Curaçao",
  },
  {
    alpha2: "DK",
    value: "DNK",
    label: "Dinamarca",
  },
  {
    alpha2: "DM",
    value: "DMA",
    label: "Dominica",
  },
  {
    alpha2: "EC",
    value: "ECU",
    label: "Ecuador",
  },
  {
    alpha2: "EG",
    value: "EGY",
    label: "Egipto",
  },
  {
    alpha2: "SV",
    value: "SLV",
    label: "El Salvador",
  },
  {
    alpha2: "AE",
    value: "ARE",
    label: "Emiratos Árabes Unidos",
  },
  {
    alpha2: "ER",
    value: "ERI",
    label: "Eritrea",
  },
  {
    alpha2: "SK",
    value: "SVK",
    label: "Eslovaquia",
  },
  {
    alpha2: "SI",
    value: "SVN",
    label: "Eslovenia",
  },
  {
    alpha2: "ES",
    value: "ESP",
    label: "España",
  },
  {
    alpha2: "US",
    value: "USA",
    label: "Estados Unidos",
  },
  {
    alpha2: "EE",
    value: "EST",
    label: "Estonia",
  },
  {
    alpha2: "ET",
    value: "ETH",
    label: "Etiopía",
  },
  {
    alpha2: "PH",
    value: "PHL",
    label: "Filipinas",
  },
  {
    alpha2: "FI",
    value: "FIN",
    label: "Finlandia",
  },
  {
    alpha2: "FJ",
    value: "FJI",
    label: "Fiyi",
  },
  {
    alpha2: "FR",
    value: "FRA",
    label: "Francia",
  },
  {
    alpha2: "GA",
    value: "GAB",
    label: "Gabón",
  },
  {
    alpha2: "GM",
    value: "GMB",
    label: "Gambia",
  },
  {
    alpha2: "GE",
    value: "GEO",
    label: "Georgia",
  },
  {
    alpha2: "GS",
    value: "SGS",
    label: "Georgia del sur y las islas sandwich del sur",
  },
  {
    alpha2: "GH",
    value: "GHA",
    label: "Ghana",
  },
  {
    alpha2: "GI",
    value: "GIB",
    label: "Gibraltar",
  },
  {
    alpha2: "GD",
    value: "GRD",
    label: "Granada",
  },
  {
    alpha2: "GR",
    value: "GRC",
    label: "Grecia",
  },
  {
    alpha2: "GL",
    value: "GRL",
    label: "Groenlandia",
  },
  {
    alpha2: "GP",
    value: "GLP",
    label: "Guadalupe",
  },
  {
    alpha2: "GU",
    value: "GUM",
    label: "Guam",
  },
  {
    alpha2: "GT",
    value: "GTM",
    label: "Guatemala",
  },
  {
    alpha2: "GF",
    value: "GUF",
    label: "Guayana Francesa",
  },
  {
    alpha2: "GG",
    value: "GGY",
    label: "Guernsey",
  },
  {
    alpha2: "GN",
    value: "GIN",
    label: "Guinea",
  },
  {
    alpha2: "GQ",
    value: "GNQ",
    label: "Guinea Ecuatorial",
  },
  {
    alpha2: "GW",
    value: "GNB",
    label: "Guinea-Bisáu",
  },
  {
    alpha2: "GY",
    value: "GUY",
    label: "Guyana",
  },
  {
    alpha2: "HT",
    value: "HTI",
    label: "Haití",
  },
  {
    alpha2: "VA",
    value: "VAT",
    label: "Holy See",
  },
  {
    alpha2: "HN",
    value: "HND",
    label: "Honduras",
  },
  {
    alpha2: "HK",
    value: "HKG",
    label: "Hong Kong",
  },
  {
    alpha2: "HU",
    value: "HUN",
    label: "Hungría",
  },
  {
    alpha2: "IN",
    value: "IND",
    label: "India",
  },
  {
    alpha2: "ID",
    value: "IDN",
    label: "Indonesia",
  },
  {
    alpha2: "IQ",
    value: "IRQ",
    label: "Irak",
  },
  {
    alpha2: "IR",
    value: "IRN",
    label: "Irán",
  },
  {
    alpha2: "IE",
    value: "IRL",
    label: "Irlanda",
  },
  {
    alpha2: "BV",
    value: "BVT",
    label: "Isla Bouvet",
  },
  {
    alpha2: "IM",
    value: "IMN",
    label: "Isla de Man",
  },
  {
    alpha2: "CX",
    value: "CXR",
    label: "Isla de Navidad",
  },
  {
    alpha2: "HM",
    value: "HMD",
    label: "Isla Heard e Islas McDonald",
  },
  {
    alpha2: "NF",
    value: "NFK",
    label: "Isla Norfolk",
  },
  {
    alpha2: "IS",
    value: "ISL",
    label: "Islandia",
  },
  {
    alpha2: "KY",
    value: "CYM",
    label: "Islas Caimán",
  },
  {
    alpha2: "CC",
    value: "CCK",
    label: "Islas Cocos",
  },
  {
    alpha2: "CK",
    value: "COK",
    label: "Islas Cook",
  },
  {
    alpha2: "UM",
    value: "UMI",
    label: "Islas de Ultramar Menores de Estados Unidos",
  },
  {
    alpha2: "FO",
    value: "FRO",
    label: "Islas Feroe",
  },
  {
    alpha2: "FK",
    value: "FLK",
    label: "Islas Malvinas",
  },
  {
    alpha2: "MP",
    value: "MNP",
    label: "Islas Marianas del Norte",
  },
  {
    alpha2: "MH",
    value: "MHL",
    label: "Islas Marshall",
  },
  {
    alpha2: "SB",
    value: "SLB",
    label: "Islas Salomón",
  },
  {
    alpha2: "TC",
    value: "TCA",
    label: "Islas Turcas y Caicos",
  },
  {
    alpha2: "VI",
    value: "VIR",
    label: "Islas Vírgenes",
  },
  {
    alpha2: "IL",
    value: "ISR",
    label: "Israel",
  },
  {
    alpha2: "IT",
    value: "ITA",
    label: "Italia",
  },
  {
    alpha2: "JM",
    value: "JAM",
    label: "Jamaica",
  },
  {
    alpha2: "JP",
    value: "JPN",
    label: "Japón",
  },
  {
    alpha2: "JE",
    value: "JEY",
    label: "Jersey",
  },
  {
    alpha2: "JO",
    value: "JOR",
    label: "Jordania",
  },
  {
    alpha2: "KZ",
    value: "KAZ",
    label: "Kazajistán",
  },
  {
    alpha2: "KE",
    value: "KEN",
    label: "Kenia",
  },
  {
    alpha2: "KG",
    value: "KGZ",
    label: "Kirguistán",
  },
  {
    alpha2: "KI",
    value: "KIR",
    label: "Kiribati",
  },
  {
    alpha2: "KP",
    value: "PRK",
    label: "Korea (Democratic People's Republic of)",
  },
  {
    alpha2: "KW",
    value: "KWT",
    label: "Kuwait",
  },
  {
    alpha2: "LA",
    value: "LAO",
    label: "Lao",
  },
  {
    alpha2: "LS",
    value: "LSO",
    label: "Lesoto",
  },
  {
    alpha2: "LV",
    value: "LVA",
    label: "Letonia",
  },
  {
    alpha2: "LB",
    value: "LBN",
    label: "Líbano",
  },
  {
    alpha2: "LR",
    value: "LBR",
    label: "Liberia",
  },
  {
    alpha2: "LY",
    value: "LBY",
    label: "Libia",
  },
  {
    alpha2: "LI",
    value: "LIE",
    label: "Liechtenstein",
  },
  {
    alpha2: "LT",
    value: "LTU",
    label: "Lituania",
  },
  {
    alpha2: "LU",
    value: "LUX",
    label: "Luxemburgo",
  },
  {
    alpha2: "MO",
    value: "MAC",
    label: "Macao",
  },
  {
    alpha2: "MK",
    value: "MKD",
    label: "Macedonia",
  },
  {
    alpha2: "MG",
    value: "MDG",
    label: "Madagascar",
  },
  {
    alpha2: "MY",
    value: "MYS",
    label: "Malasia",
  },
  {
    alpha2: "MW",
    value: "MWI",
    label: "Malaui",
  },
  {
    alpha2: "MV",
    value: "MDV",
    label: "Maldivas",
  },
  {
    alpha2: "ML",
    value: "MLI",
    label: "Malí",
  },
  {
    alpha2: "MT",
    value: "MLT",
    label: "Malta",
  },
  {
    alpha2: "MA",
    value: "MAR",
    label: "Marruecos",
  },
  {
    alpha2: "MQ",
    value: "MTQ",
    label: "Martinica",
  },
  {
    alpha2: "MU",
    value: "MUS",
    label: "Mauricio",
  },
  {
    alpha2: "MR",
    value: "MRT",
    label: "Mauritania",
  },
  {
    alpha2: "YT",
    value: "MYT",
    label: "Mayotte",
  },
  {
    alpha2: "MX",
    value: "MEX",
    label: "México",
  },
  {
    alpha2: "FM",
    value: "FSM",
    label: "Micronesia",
  },
  {
    alpha2: "MD",
    value: "MDA",
    label: "Moldavia",
  },
  {
    alpha2: "MC",
    value: "MCO",
    label: "Mónaco",
  },
  {
    alpha2: "MN",
    value: "MNG",
    label: "Mongolia",
  },
  {
    alpha2: "ME",
    value: "MNE",
    label: "Montenegro",
  },
  {
    alpha2: "MS",
    value: "MSR",
    label: "Montserrat",
  },
  {
    alpha2: "MZ",
    value: "MOZ",
    label: "Mozambique",
  },
  {
    alpha2: "MM",
    value: "MMR",
    label: "Myanmar",
  },
  {
    alpha2: "NA",
    value: "NAM",
    label: "Namibia",
  },
  {
    alpha2: "NR",
    value: "NRU",
    label: "Nauru",
  },
  {
    alpha2: "NP",
    value: "NPL",
    label: "Nepal",
  },
  {
    alpha2: "NI",
    value: "NIC",
    label: "Nicaragua",
  },
  {
    alpha2: "NE",
    value: "NER",
    label: "Níger",
  },
  {
    alpha2: "NG",
    value: "NGA",
    label: "Nigeria",
  },
  {
    alpha2: "NU",
    value: "NIU",
    label: "Niue",
  },
  {
    alpha2: "NO",
    value: "NOR",
    label: "Noruega",
  },
  {
    alpha2: "NC",
    value: "NCL",
    label: "Nueva Caledonia",
  },
  {
    alpha2: "NZ",
    value: "NZL",
    label: "Nueva Zelanda",
  },
  {
    alpha2: "OM",
    value: "OMN",
    label: "Omán",
  },
  {
    alpha2: "NL",
    value: "NLD",
    label: "Países Bajos",
  },
  {
    alpha2: "PK",
    value: "PAK",
    label: "Pakistán",
  },
  {
    alpha2: "PW",
    value: "PLW",
    label: "Palaos",
  },
  {
    alpha2: "PS",
    value: "PSE",
    label: "Palestina, Estado de",
  },
  {
    alpha2: "PA",
    value: "PAN",
    label: "Panamá",
  },
  {
    alpha2: "PG",
    value: "PNG",
    label: "Papúa Nueva Guinea",
  },
  {
    alpha2: "PY",
    value: "PRY",
    label: "Paraguay",
  },
  {
    alpha2: "PE",
    value: "PER",
    label: "Perú",
  },
  {
    alpha2: "PN",
    value: "PCN",
    label: "Pitcairn",
  },
  {
    alpha2: "PF",
    value: "PYF",
    label: "Polinesia Francesa",
  },
  {
    alpha2: "PL",
    value: "POL",
    label: "Polonia",
  },
  {
    alpha2: "PT",
    value: "PRT",
    label: "Portugal",
  },
  {
    alpha2: "PR",
    value: "PRI",
    label: "Puerto Rico",
  },
  {
    alpha2: "GB",
    value: "GBR",
    label: "Reino Unido",
  },
  {
    alpha2: "CF",
    value: "CAF",
    label: "República Centroafricana",
  },
  {
    alpha2: "CZ",
    value: "CZE",
    label: "República Checa",
  },
  {
    alpha2: "DO",
    value: "DOM",
    label: "República Dominicana",
  },
  {
    alpha2: "RE",
    value: "REU",
    label: "Reunión",
  },
  {
    alpha2: "RW",
    value: "RWA",
    label: "Ruanda",
  },
  {
    alpha2: "RO",
    value: "ROU",
    label: "Rumania",
  },
  {
    alpha2: "RU",
    value: "RUS",
    label: "Rusia",
  },
  {
    alpha2: "EH",
    value: "ESH",
    label: "Sahara Occidental",
  },
  {
    alpha2: "WS",
    value: "WSM",
    label: "Samoa",
  },
  {
    alpha2: "AS",
    value: "ASM",
    label: "Samoa Americana",
  },
  {
    alpha2: "BL",
    value: "BLM",
    label: "San Bartolomé",
  },
  {
    alpha2: "KN",
    value: "KNA",
    label: "San Cristóbal y Nieves",
  },
  {
    alpha2: "SM",
    value: "SMR",
    label: "San Marino",
  },
  {
    alpha2: "MF",
    value: "MAF",
    label: "San Martín",
  },
  {
    alpha2: "PM",
    value: "SPM",
    label: "San Pedro y Miquelón",
  },
  {
    alpha2: "VC",
    value: "VCT",
    label: "San Vicente y las Granadinas",
  },
  {
    alpha2: "SH",
    value: "SHN",
    label: "Santa Helena",
  },
  {
    alpha2: "LC",
    value: "LCA",
    label: "Santa Lucía",
  },
  {
    alpha2: "ST",
    value: "STP",
    label: "Santo Tomé y Príncipe",
  },
  {
    alpha2: "SN",
    value: "SEN",
    label: "Senegal",
  },
  {
    alpha2: "RS",
    value: "SRB",
    label: "Serbia",
  },
  {
    alpha2: "SC",
    value: "SYC",
    label: "Seychelles",
  },
  {
    alpha2: "SL",
    value: "SLE",
    label: "Sierra leona",
  },
  {
    alpha2: "SG",
    value: "SGP",
    label: "Singapur",
  },
  {
    alpha2: "SX",
    value: "SXM",
    label: "Sint Maarten",
  },
  {
    alpha2: "SY",
    value: "SYR",
    label: "Siria",
  },
  {
    alpha2: "SO",
    value: "SOM",
    label: "Somalia",
  },
  {
    alpha2: "LK",
    value: "LKA",
    label: "Sri Lanka",
  },
  {
    alpha2: "SZ",
    value: "SWZ",
    label: "Suazilandia",
  },
  {
    alpha2: "ZA",
    value: "ZAF",
    label: "Sudáfrica",
  },
  {
    alpha2: "SD",
    value: "SDN",
    label: "Sudán",
  },
  {
    alpha2: "SS",
    value: "SSD",
    label: "Sudán del Sur",
  },
  {
    alpha2: "SE",
    value: "SWE",
    label: "Suecia",
  },
  {
    alpha2: "CH",
    value: "CHE",
    label: "Suiza",
  },
  {
    alpha2: "SR",
    value: "SUR",
    label: "Surinam",
  },
  {
    alpha2: "SJ",
    value: "SJM",
    label: "Svalbard y Jan Mayen",
  },
  {
    alpha2: "TH",
    value: "THA",
    label: "Tailandia",
  },
  {
    alpha2: "TW",
    value: "TWN",
    label: "Taiwán",
  },
  {
    alpha2: "TZ",
    value: "TZA",
    label: "Tanzania",
  },
  {
    alpha2: "TJ",
    value: "TJK",
    label: "Tayikistán",
  },
  {
    alpha2: "IO",
    value: "IOT",
    label: "Territorio Británico del Océano Índico",
  },
  {
    alpha2: "TF",
    value: "ATF",
    label: "Territorios Australes Franceses",
  },
  {
    alpha2: "TL",
    value: "TLS",
    label: "Timor-Leste",
  },
  {
    alpha2: "TG",
    value: "TGO",
    label: "Togo",
  },
  {
    alpha2: "TK",
    value: "TKL",
    label: "Tokelau",
  },
  {
    alpha2: "TO",
    value: "TON",
    label: "Tonga",
  },
  {
    alpha2: "TT",
    value: "TTO",
    label: "Trinidad y Tobago",
  },
  {
    alpha2: "TN",
    value: "TUN",
    label: "Túnez",
  },
  {
    alpha2: "TM",
    value: "TKM",
    label: "Turkmenistán",
  },
  {
    alpha2: "TR",
    value: "TUR",
    label: "Turquía",
  },
  {
    alpha2: "TV",
    value: "TUV",
    label: "Tuvalu",
  },
  {
    alpha2: "UA",
    value: "UKR",
    label: "Ucrania",
  },
  {
    alpha2: "UG",
    value: "UGA",
    label: "Uganda",
  },
  {
    alpha2: "UY",
    value: "URY",
    label: "Uruguay",
  },
  {
    alpha2: "UZ",
    value: "UZB",
    label: "Uzbekistán",
  },
  {
    alpha2: "VU",
    value: "VUT",
    label: "Vanuatu",
  },
  {
    alpha2: "VE",
    value: "VEN",
    label: "Venezuela",
  },
  {
    alpha2: "VN",
    value: "VNM",
    label: "Vietnam",
  },
  {
    alpha2: "VG",
    value: "VGB",
    label: "Virgin Islands (British)",
  },
  {
    alpha2: "WF",
    value: "WLF",
    label: "Wallis y Futuna",
  },
  {
    alpha2: "YE",
    value: "YEM",
    label: "Yemen",
  },
  {
    alpha2: "DJ",
    value: "DJI",
    label: "Yibuti",
  },
  {
    alpha2: "ZM",
    value: "ZMB",
    label: "Zambia",
  },
  {
    alpha2: "ZW",
    value: "ZWE",
    label: "Zimbabue",
  },
];
